import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { SHIPMENT_PROGRESS_STATUS } from 'domains/customer-order/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerOrderShipmentProgressStatusBadge = ({ status }) => {

  const colorMap = {
    [SHIPMENT_PROGRESS_STATUS.PENDING]    : 'warning',
    [SHIPMENT_PROGRESS_STATUS.PROCESSING] : 'info',
    [SHIPMENT_PROGRESS_STATUS.COMPLETED]  : 'success',
    [SHIPMENT_PROGRESS_STATUS.CANCELLED]  : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerOrderShipmentProgressStatusBadge.propTypes = propTypes

export default CustomerOrderShipmentProgressStatusBadge